'use strict';
const px = require('../dom/px');
module.exports = function shadowDraggable(domElement, stage) {
	let dragShadow;
	const onDragStart = e => {
			const boundingRect = domElement.getBoundingClientRect(),
				clientX = e.clientX,
				clientY = e.clientY,
				insetX = clientX - boundingRect.x,
				insetY = clientY - boundingRect.y,
				scale = stage.getStageData().scale,
				unscaledWidth = boundingRect.width / scale,
				dragShadowNode = domElement.cloneNode(true);

			dragShadowNode.style.boxShadow = 'none';
			dragShadowNode.style.position = '';
			dragShadowNode.style.top = px(0);
			dragShadowNode.style.left = px(0);
			dragShadowNode.style.margin = px(0);
			dragShadowNode.removeAttribute('id');
			dragShadowNode.removeAttribute('draggable');
			dragShadow = domElement.ownerDocument.createElement('div');

			dragShadow.style.position = 'absolute';
			dragShadow.style.top = px(-1 * boundingRect.height);
			dragShadow.style.width = px(Math.ceil(boundingRect.width));
			dragShadow.style.height = px(Math.ceil(boundingRect.height));

			if (scale !== 1) {
				dragShadowNode.style.width = px(unscaledWidth);
				dragShadowNode.style.boxSizing = 'border-box';
				dragShadowNode.style.transformOrigin = 'top left';
				dragShadowNode.style.transform = `scale(${scale})`;
			}
			dragShadow.appendChild(dragShadowNode);
			domElement.ownerDocument.body.appendChild(dragShadow);
			e.dataTransfer.setDragImage(dragShadow, insetX, insetY);
		},
		onDragEnd = () => {
			if (dragShadow) {
				dragShadow.remove();
			}
			dragShadow = false;
		};
	domElement.setAttribute('draggable', 'true');
	domElement.addEventListener('dragstart', onDragStart);
	domElement.addEventListener('dragend', onDragEnd);
};
